import React from 'react';
import { FormSelect } from '@getro/rombo';
import { useTheme } from 'styled-components';

export const FormExtraOptions = (props) => {
  const { colors } = useTheme();
  return (
    <FormSelect
      {...props}
      size="small"
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      styles={{
        control: (provided) => ({
          ...provided,
          padding: '0px',
          minHeight: '16px',
          border: 0,
          boxShadow: 'none',

          '& > div': {
            padding: '0px',
            height: '16px',
            border: 0,
            gap: '4px',
          },
        }),
        singleValue: (provided) => ({
          ...provided,
          position: 'relative',
          top: '0px',
          transform: 'translateY(0px)',
          padding: '0px',
          margin: 0,
          fontSize: '12px',
          color: colors.text.subtle,
        }),
        valueContainer: (provided) => ({
          ...provided,
          padding: '0px',
          maxWidth: 'fit-content',

          '& input': {
            position: 'absolute',
          },
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          padding: '0px',
          '& > div': {
            position: 'relative',
            top: '0px',
            right: '0px',
            transform: 'translateY(0px)',
            height: '16px',
            width: '16px',
          },
        }),
      }}
      anchorToBody
    />
  );
};
